<div class="shortened-vehicle-info">
  <span *ngIf="showRegistrationNumber">{{ 'SHORTENED-VEHICLE-INFO_COMPONENT.registrationNumber' | translate }} - <span class="shortened-vehicle-info__value">{{ vehicleData?.registrationNumber }}</span></span><br>
  {{ 'SHORTENED-VEHICLE-INFO_COMPONENT.model' | translate }} - <span class="shortened-vehicle-info__value">{{ vehicleModelState?.modelName }}</span><br>
  {{ 'SHORTENED-VEHICLE-INFO_COMPONENT.startInsuranceDate' | translate }} - <span class="shortened-vehicle-info__value">{{ insuranceData?.startInsuranceDate | date: 'dd.MM.yyyy' }}</span>
  <div class="right-arrow-btn-wrapper">
    <button class="btn btn--clear btn--no-outline" (click)="backToVehicleData()">
        {{ 'SHORTENED-VEHICLE-INFO_COMPONENT.editData' | translate }}
        <span class="material-icons">arrow_right</span>
    </button>
  </div>
</div>
